/** Takes the title prop for icons, and replaces all whitespace with '-' */
const convertTitleToId = (title) => {
    return title.replace(/ /g, '-');
};
export default convertTitleToId;
